import React, { FC, memo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import Image from 'next/image'
import { Text } from '@ucheba/ui/components/Text/desktop'
import Link from 'next/link'
import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { getApiImageUrl } from '@ucheba/utils/helpers/string'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Param } from '@ucheba/ui/components/Param/desktop'
import { IProfessionsListItemProps } from '../types'
import SC from '../base/ProfessionsListItem.styles'
import { imageWH } from '../contants'
import { useImageColWidth, useProfessionHref, useProfessionsListItemCore } from '../bll'

const { Block } = SC

const ImageBox = styled.a`
  width: ${imageWH};
  height: ${imageWH};
  position: relative;
  display: block;

  img {
    border-radius: ${sv.radius.large};
    overflow: hidden;
    transition: ${sv.duration.medium};

    &:hover {
      transform: scale(0.98);
      filter: contrast(130%);
    }
  }
`

const Wrap = styled.div`
  display: flex;
`

const A = styled(Link)`
  display: inline-block;
  margin-right: 16px;
`

/** Профессия */
const ProfessionsListItem: FC<IProfessionsListItemProps> = (props) => {
  const { id, name, description, imagePath } = props

  const href = useProfessionHref(id)
  const imageColWidth = useImageColWidth(imageWH)

  const { institutions, collages, courses, hrefVuzs, hrefCollage, hrefCourse } =
    useProfessionsListItemCore(props)

  return (
    <Block>
      <Grid nowrap>
        {imagePath && (
          <GridCol width={imageColWidth}>
            <Link href={href} passHref>
              <ImageBox>
                <Image
                  src={getApiImageUrl(imagePath)}
                  layout='fill'
                  objectFit='cover'
                  alt={name}
                  loading='lazy'
                />
              </ImageBox>
            </Link>
          </GridCol>
        )}

        <GridCol shrink='initial'>
          <Link href={href}>
            <Heading h3={name} href={href} spacing='xxsmall' color='blue' />
          </Link>

          {description && <Text>{description}</Text>}

          <Spacing spacing='xsmall' />

          <Wrap>
            {institutions && (
              <A href={hrefVuzs} passHref>
                <Param
                  entity={institutions.entity}
                  clarification={institutions.clarification}
                  color='blue'
                  fontSize='large'
                />
              </A>
            )}

            {collages && (
              <A href={hrefCollage} passHref>
                <Param
                  entity={collages.entity}
                  clarification={collages.clarification}
                  color='blue'
                  fontSize='large'
                />
              </A>
            )}

            {courses && (
              <A href={hrefCourse} passHref>
                <Param
                  entity={courses.entity}
                  clarification={courses.clarification}
                  color='blue'
                  fontSize='large'
                />
              </A>
            )}
          </Wrap>
        </GridCol>
      </Grid>
    </Block>
  )
}

export { ProfessionsListItem }
export default memo(ProfessionsListItem)
